var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.835 18.6279C19.8367 18.6279 20.2783 17.9003 19.8171 17.0111L11.3288 0.66685C10.8671 -0.222283 10.1117 -0.222283 9.65004 0.66685L1.16167 17.0117C0.699432 17.9003 1.14155 18.6279 2.14325 18.6279H18.835Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8035 15.3404C11.8035 14.6155 11.2134 14.0255 10.488 14.0255C9.76308 14.0255 9.17305 14.6155 9.17305 15.3404C9.17305 16.0658 9.76363 16.6559 10.488 16.6559C11.2134 16.6559 11.8035 16.0658 11.8035 15.3404ZM11.7023 5.39245C11.7023 4.68441 11.1797 4.24609 10.4885 4.24609C9.81366 4.24609 9.2742 4.70126 9.2742 5.39245V11.8845C9.2742 12.5757 9.81366 13.0308 10.4885 13.0308C11.1797 13.0308 11.7023 12.592 11.7023 11.8845V5.39245Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.fedcad0107952f32e0a6fdc1ab004eeb.svg";
export { ForwardRef as ReactComponent };